import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Rotate Counter-Clockwise icon for restart/refresh
 */
export const RotateCcwIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polyline points="1 4 1 10 7 10"></polyline>
      <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
    </Icon>
  );
};

export default RotateCcwIcon;
